import { FC } from 'react';
import { SEVERITIES_INFO } from '../../../../consts/Severity';

interface Props {
    severity: number;
}

const getBarColor = (severity: number, barIndex: number) => {
    if (barIndex <= severity) {
        return SEVERITIES_INFO[severity].color;
    }

    return 'sf-gray-300';
};

const SeverityColumn: FC<Props> = ({ severity }) => {
    return (
        <div className="w-9 h-6 flex justify-center items-end gap-1">
            <div className={`bg-${getBarColor(severity, 1)} w-1 h-[7px] flex-shrink-0 rounded-[1px]`} />
            <div className={`bg-${getBarColor(severity, 2)} w-1 h-[10px] flex-shrink-0 rounded-[1px]`} />
            <div className={`bg-${getBarColor(severity, 3)} w-1 h-[13px] flex-shrink-0 rounded-[1px]`} />
            <div className={`bg-${getBarColor(severity, 4)} w-1 h-4 flex-shrink-0 rounded-[1px]`} />
        </div>
    );
};

export default SeverityColumn;
